import React from 'react'
import { joinClassNames } from '../../utilities'
import css from './ConfirmationEmail.module.css'
import { Divider } from '../divider'

export const ConfirmationEmail = propOverrides => {
  const props = {
    className: '',
    title: 'Email receipt of complaint submission',
    message:
      'Do you wish to receive an email receipt of this complaint submission? The receipt does NOT include your complaint responses.',
    ...propOverrides
  }
  const classes = joinClassNames(css.printReview, props.className)

  return (
    <div className={classes}>
      <h2>{props.title}</h2>
      <div className="ds-text--lead">{props.message}</div>
      <Divider />
    </div>
  )
}
